/**
 * The code is based on 'ng2-file-upload' library (https://github.com/valor-software/ng2-file-upload)
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Dmitriy Shekhovtsov <valorkin@gmail.com>
 * Copyright (c) 2015 Valor Software
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    inject,
    Input,
    Output
} from "@angular/core";
import { FileUploader, FileUploaderOptions } from "../models";

/**
 * Directive to detect file(s) selection on html form inputs `<input type="file" />`.
 */
@Directive({
    selector: "[lgFileSelect]"
})
export class FileSelectDirective {
    protected element = inject(ElementRef<HTMLInputElement>);

    /**
     * File uploader class.
     */
    @Input()
    uploader: FileUploader = new FileUploader({ url: "" });

    /**
     * Emits list of files that have been selected on html input and added to the Uploader queue.
     */
    @Output()
    readonly fileSelected: EventEmitter<FileList> = new EventEmitter<FileList>();

    @HostListener("change")
    onChange(): void {
        const files = this.element.nativeElement.files;
        const options = this.getOptions();
        const filters = this.getFilters();
        this.uploader.addToQueue(files, options, filters);

        this.fileSelected.emit(files);
        if (this.isEmptyAfterSelection()) {
            this.element.nativeElement.value = "";
        }
    }

    getOptions(): FileUploaderOptions | undefined {
        return this.uploader.options;
    }

    getFilters(): string {
        return "";
    }

    isEmptyAfterSelection(): boolean {
        return !!this.element.nativeElement.attributes.multiple;
    }
}
